import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full acontent" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("titles.ml_components"))),
      ]),
      _vm._t("default"),
      _c(
        "actions-component",
        { attrs: { class_table: _vm.getClassTable } },
        [
          _c(
            "template",
            { slot: "actions" },
            [
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { dense: "", outlined: "" },
                  on: {
                    click: function ($event) {
                      return _vm.onOpenApiDoc()
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [_vm._v("mdi-api")]),
                  _vm._v(" " + _vm._s("API Doc.") + " "),
                ],
                1
              ),
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { dense: "", outlined: "" },
                  on: { click: _vm.onEnableFilter },
                },
                [
                  _vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-off-outline"),
                      ])
                    : _vm._e(),
                  !_vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-outline"),
                      ])
                    : _vm._e(),
                  _vm._v(" " + _vm._s(_vm.$t("botones.boton_filtrar")) + " "),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _vm.filter_enabled
        ? _c(
            VCard,
            { staticClass: "filters-inca d-block d-md-none mb-2" },
            [
              _c(VCardTitle, { staticClass: "pointer pb-0" }, [
                _vm._v(" " + _vm._s(_vm.$t("titles.search_filters")) + " "),
              ]),
              _c(
                VCardText,
                [
                  _c(VRow, { attrs: { dense: "dense" } }, [
                    _c(
                      "div",
                      { staticClass: "col-md-3 text-right" },
                      [
                        _c(
                          VBtn,
                          {
                            staticClass: "default mr-1",
                            attrs: { outlined: "outlined" },
                            on: { click: _vm.onLimpiar },
                          },
                          [_vm._v(_vm._s(_vm.$t("btns.clean")))]
                        ),
                        _c(
                          VBtn,
                          {
                            staticClass: "primary",
                            on: { click: _vm.onSearch },
                          },
                          [_vm._v(_vm._s(_vm.$t("btns.search")))]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(VRow, [
        _c(
          "div",
          { class: _vm.getClassTable },
          [
            _c(
              VCard,
              [
                _c(VDataTable, {
                  key: _vm.key_table,
                  staticClass: "table-inca",
                  attrs: {
                    headers: _vm.headers,
                    items: _vm.componentes,
                    "sort-by": _vm.pagination.sort_by,
                    "sort-desc": _vm.pagination.sort_desc,
                    "hide-default-footer": true,
                    page: _vm.pagination.current,
                  },
                  on: {
                    "update:page": function ($event) {
                      return _vm.$set(_vm.pagination, "current", $event)
                    },
                    pagination: function ($event) {
                      _vm.pagination.total = $event.itemsLength
                    },
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "item.request_date",
                      fn: function (ref) {
                        var item = ref.item
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.formatDateLast(item.request_date))
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "item.acciones",
                      fn: function (ref) {
                        var item = ref.item
                        return [
                          item.compile_file &&
                          item.compile_file.path &&
                          item.compile_envar &&
                          item.compile_envar.path &&
                          (!item.shared || (item.shared && item.execute))
                            ? _c(
                                VBtn,
                                {
                                  staticClass: "btn-icon-inca",
                                  attrs: { icon: "", small: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.executePipeline(item)
                                    },
                                  },
                                },
                                [
                                  _c(VIcon, { attrs: { small: "" } }, [
                                    _vm._v(" mdi-play-box "),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          item.last_execution_id
                            ? _c(
                                VBtn,
                                {
                                  staticClass: "btn-icon-inca",
                                  attrs: { icon: "", small: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onOpenListExecution(item)
                                    },
                                  },
                                },
                                [
                                  _c(VIcon, { attrs: { small: "" } }, [
                                    _vm._v(" icon-tasks "),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            VBtn,
                            {
                              staticClass: "btn-icon-inca",
                              attrs: { icon: "", small: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.onOpenShareComponent(item)
                                },
                              },
                            },
                            [
                              _c(VIcon, { attrs: { small: "" } }, [
                                _vm._v(" mdi-account-multiple "),
                              ]),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _c("pagination-vue", { attrs: { pagination: _vm.pagination } }),
          ],
          1
        ),
        _vm.filter_enabled
          ? _c(
              "div",
              { staticClass: "col-md-3 d-none d-md-block pl-0" },
              [
                _c(
                  VCard,
                  { staticClass: "filters-inca" },
                  [
                    _c(
                      VCardTitle,
                      {
                        staticClass: "pointer pb-0",
                        on: {
                          click: function ($event) {
                            _vm.collapse_filter = !_vm.collapse_filter
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("titles.search_filters")) + " "
                        ),
                      ]
                    ),
                    _c(
                      VCardText,
                      { staticClass: "pa-2 pt-0" },
                      [
                        _c(
                          VRow,
                          { attrs: { dense: "dense" } },
                          [
                            _c(
                              VCol,
                              { staticClass: "mb-2", attrs: { cols: "12" } },
                              [
                                _c(VTextField, {
                                  attrs: {
                                    label: _vm.filtros.name,
                                    placeholder: _vm.filtros.name,
                                    outlined: "",
                                    dense: "",
                                    "hide-details": "auto",
                                  },
                                  model: {
                                    value: _vm.filters.name,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.filters, "name", $$v)
                                    },
                                    expression: "filters.name",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { staticClass: "mb-2", attrs: { cols: "12" } },
                              [
                                _c(VSelect, {
                                  attrs: {
                                    label: _vm.filtros.type,
                                    outlined: "",
                                    dense: "",
                                    "hide-details": "auto",
                                    items: _vm.types,
                                  },
                                  on: { change: _vm.onChangeType },
                                  model: {
                                    value: _vm.filters.type,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.filters, "type", $$v)
                                    },
                                    expression: "filters.type",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { staticClass: "mb-2", attrs: { cols: "12" } },
                              [
                                _c(
                                  VMenu,
                                  {
                                    ref: "menu2",
                                    attrs: {
                                      "close-on-content-click": false,
                                      "return-value": _vm.dates,
                                      transition: "scale-transition",
                                      "offset-y": "",
                                      "max-width": "290px",
                                      "min-width": "290px",
                                    },
                                    on: {
                                      "update:returnValue": function ($event) {
                                        _vm.dates = $event
                                      },
                                      "update:return-value": function ($event) {
                                        _vm.dates = $event
                                      },
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function (ref) {
                                            var on = ref.on
                                            var attrs = ref.attrs
                                            return [
                                              _c(
                                                VTextField,
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      attrs: {
                                                        "append-icon": "event",
                                                        readonly: "",
                                                        dense: "",
                                                        outlined: "",
                                                        "hide-details": "auto",
                                                        label: "Fecha Creación",
                                                      },
                                                      on: {
                                                        "click:append":
                                                          on.click,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.dateRangeText,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.dateRangeText =
                                                            $$v
                                                        },
                                                        expression:
                                                          "dateRangeText",
                                                      },
                                                    },
                                                    "v-text-field",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                )
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1445720853
                                    ),
                                    model: {
                                      value: _vm.menu2,
                                      callback: function ($$v) {
                                        _vm.menu2 = $$v
                                      },
                                      expression: "menu2",
                                    },
                                  },
                                  [
                                    _c(
                                      VDatePicker,
                                      {
                                        attrs: { range: "", scrollabel: "" },
                                        model: {
                                          value: _vm.filters.fechas,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.filters, "fechas", $$v)
                                          },
                                          expression: "filters.fechas",
                                        },
                                      },
                                      [
                                        _c(VSpacer),
                                        _c(
                                          VBtn,
                                          {
                                            attrs: {
                                              text: "",
                                              color: "primary",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onLimpiarFiltroFecha()
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$t("btns.clean")))]
                                        ),
                                        _c(
                                          VBtn,
                                          {
                                            attrs: {
                                              text: "",
                                              color: "primary",
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.menu2 = false
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("btns.cancel"))
                                            ),
                                          ]
                                        ),
                                        _c(
                                          VBtn,
                                          {
                                            attrs: {
                                              text: "",
                                              color: "primary",
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.menu2 = false
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$t("btns.ok")))]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              {
                                staticClass: "text-right",
                                attrs: { cols: "12" },
                              },
                              [
                                _c(
                                  VBtn,
                                  {
                                    staticClass: "default mr-1",
                                    attrs: { outlined: "outlined" },
                                    on: { click: _vm.onLimpiar },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("btns.clean")))]
                                ),
                                _c(
                                  VBtn,
                                  {
                                    staticClass: "primary",
                                    on: { click: _vm.onSearch },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("btns.search")))]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c(
        "dialog-confirmation-component",
        {
          ref: "MODAL_CONFIRM_EXECUTE",
          attrs: {
            title: "Confirmación",
            text: "¿Esta seguro de EJECUTAR la canalización?",
            width: 600,
          },
          on: { onConfirm: _vm.onConfirmExecutePipeline },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c(
                VForm,
                { staticClass: "mb-0", attrs: { "lazy-validation": "" } },
                [
                  _c(
                    "div",
                    { staticClass: "col-12 mt-2" },
                    _vm._l(
                      _vm.item_selected && _vm.item_selected.parameters
                        ? _vm.item_selected.parameters
                        : [],
                      function (element) {
                        return _c(
                          VRow,
                          {
                            staticClass: "row pb-2",
                            attrs: { cols: "12", dense: "" },
                          },
                          [
                            _c(VCol, { attrs: { cols: "4" } }, [
                              _c("div", { staticClass: "text-subtitle-1" }, [
                                _vm._v(" " + _vm._s(element.name) + " "),
                                _c("br"),
                                _c("h6", { staticClass: "text-subtitle-2" }, [
                                  _vm._v(
                                    "(" + _vm._s(element.description) + ")"
                                  ),
                                ]),
                              ]),
                            ]),
                            _c(
                              VCol,
                              { attrs: { cols: "8" } },
                              [
                                _c("custom-components-mlops", {
                                  attrs: {
                                    element: element,
                                    value: element.default,
                                  },
                                  model: {
                                    value: _vm.parameters_execute[element.name],
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.parameters_execute,
                                        element.name,
                                        $$v
                                      )
                                    },
                                    expression:
                                      "parameters_execute[element.name]",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }
                    ),
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: "MODAL_LIST_PERMISSIONS",
          attrs: {
            title:
              "Permisos: " + (_vm.item_selected ? _vm.item_selected.name : ""),
            width: 800,
          },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _vm.item_selected && !_vm.item_selected.shared
                ? _c(
                    VBtn,
                    {
                      on: {
                        click: function ($event) {
                          return _vm.onAgregarPermission()
                        },
                      },
                    },
                    [_vm._v("Agregar")]
                  )
                : _vm._e(),
              _c(VDataTable, {
                key: _vm.key_table_permissions,
                staticClass: "table-inca",
                attrs: {
                  headers: _vm.headers_permissions,
                  items: _vm.permissions,
                  "sort-by": _vm.pagination_permissions.sort_by,
                  "sort-desc": _vm.pagination_permissions.sort_desc,
                  "hide-default-footer": true,
                  page: _vm.pagination_permissions.current,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(
                      _vm.pagination_permissions,
                      "current",
                      $event
                    )
                  },
                  pagination: function ($event) {
                    _vm.pagination_permissions.total = $event.itemsLength
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.user",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _c(VTextField, {
                          attrs: {
                            outlined: "",
                            small: "",
                            dense: "",
                            "hide-details": "auto",
                            disabled:
                              _vm.item_selected && _vm.item_selected.shared,
                          },
                          model: {
                            value: item.user,
                            callback: function ($$v) {
                              _vm.$set(item, "user", $$v)
                            },
                            expression: "item.user",
                          },
                        }),
                      ]
                    },
                  },
                  {
                    key: "item.view",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _c(VCheckbox, {
                          staticClass: "mt-0",
                          attrs: {
                            readonly: "",
                            "hide-details": "auto",
                            disabled:
                              _vm.item_selected && _vm.item_selected.shared,
                          },
                          model: {
                            value: _vm.isChecked,
                            callback: function ($$v) {
                              _vm.isChecked = $$v
                            },
                            expression: "isChecked",
                          },
                        }),
                      ]
                    },
                  },
                  {
                    key: "item.execute",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _c(VCheckbox, {
                          staticClass: "mt-0",
                          attrs: {
                            "hide-details": "auto",
                            disabled:
                              _vm.item_selected && _vm.item_selected.shared,
                          },
                          model: {
                            value: item.execute,
                            callback: function ($$v) {
                              _vm.$set(item, "execute", $$v)
                            },
                            expression: "item.execute",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _vm.item_selected && !_vm.item_selected.shared
                ? _c(
                    VBtn,
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.onGuardarPermissions()
                        },
                      },
                    },
                    [_vm._v(" Guardar ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: "MODAL_LIST_EXECUTIONS",
          attrs: { title: "Lista de Ejecuciones", width: 1200 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              !_vm.see_detail
                ? _c(VDataTable, {
                    key: _vm.key_table_executions,
                    staticClass: "table-inca",
                    attrs: {
                      headers: _vm.headers_executions,
                      items: _vm.executions,
                      "sort-by": _vm.pagination_executions.sort_by,
                      "sort-desc": _vm.pagination_executions.sort_desc,
                      "hide-default-footer": true,
                      page: _vm.pagination_executions.current,
                    },
                    on: {
                      "update:page": function ($event) {
                        return _vm.$set(
                          _vm.pagination_executions,
                          "current",
                          $event
                        )
                      },
                      pagination: function ($event) {
                        _vm.pagination_executions.total = $event.itemsLength
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "item.actions",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _vm.item_selected &&
                              (!_vm.item_selected.shared ||
                                (_vm.item_selected.shared &&
                                  _vm.item_selected.execute))
                                ? _c(
                                    VBtn,
                                    {
                                      staticClass: "btn-icon-inca",
                                      attrs: { text: "", small: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onPingExecution(item)
                                        },
                                      },
                                    },
                                    [
                                      _c(VIcon, [_vm._v("mdi-broadcast")]),
                                      _vm._v(" PING"),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                VBtn,
                                {
                                  staticClass: "btn-icon-inca",
                                  attrs: { text: "", small: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onViewDetailExecution(item)
                                    },
                                  },
                                },
                                [
                                  _c(VIcon, [_vm._v("icon-view")]),
                                  _vm._v(" DETALLE"),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2788983211
                    ),
                  })
                : _vm._e(),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.see_detail,
                      expression: "see_detail",
                    },
                  ],
                  staticClass: "form-row",
                },
                [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c(
                        VIcon,
                        {
                          attrs: { small: "", dense: "" },
                          on: {
                            click: function ($event) {
                              return _vm.onSeeDetail()
                            },
                          },
                        },
                        [_vm._v("mdi-close-circle")]
                      ),
                      _vm._v(" "),
                      _c("b", [_vm._v("JOB: ")]),
                      _vm._v(_vm._s(_vm.detail_execution.name) + " "),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "col-7" }, [
                    _c("div", {
                      staticStyle: { "background-color": "#fff !important" },
                      attrs: { id: "container" },
                    }),
                  ]),
                  _c(
                    "div",
                    { staticClass: "col-5" },
                    [
                      _c(
                        VTabs,
                        [
                          _c(VTab, [_vm._v("RESUMEN")]),
                          _c(VTab, [_vm._v("INFORMACIÓN DEL NODO")]),
                          _c(
                            VTabItem,
                            [
                              _c("br"),
                              _c("label", [_vm._v("Información básica")]),
                              _c("table", [
                                _c("tr", [
                                  _c("th", [_vm._v("Duración")]),
                                  _c("td"),
                                ]),
                                _c("tr", [
                                  _c("th", [_vm._v("Inicio")]),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.detail_execution.create_time
                                          ? _vm.detail_execution.create_time
                                              .substring(0, 19)
                                              .replace("T", " ")
                                          : ""
                                      )
                                    ),
                                  ]),
                                ]),
                                _c("tr", [
                                  _c("th", [_vm._v("Completado")]),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.detail_execution.update_time
                                          ? _vm.detail_execution.update_time
                                              .substring(0, 19)
                                              .replace("T", " ")
                                          : ""
                                      )
                                    ),
                                  ]),
                                ]),
                                _c("tr", [
                                  _c("th", [_vm._v("Nombre de la ejecución")]),
                                  _c("td", [
                                    _vm._v(_vm._s(_vm.detail_execution.name)),
                                  ]),
                                ]),
                                _c("tr", [
                                  _c("th", [
                                    _vm._v("Nombre de la canalización"),
                                  ]),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(_vm.detail_execution.display_name)
                                    ),
                                  ]),
                                ]),
                                _c("tr", [
                                  _c("th", [_vm._v("Región")]),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(_vm.detail_execution.location)
                                    ),
                                  ]),
                                ]),
                                _c("tr", [
                                  _c("th", [_vm._v("Etiquetas")]),
                                  _c(
                                    "td",
                                    _vm._l(
                                      _vm.detail_execution.labels,
                                      function (value, key) {
                                        return _c(
                                          VChip,
                                          {
                                            key: key,
                                            staticClass: "mr-1 mb-1",
                                            attrs: { small: "" },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(key) + ":" + _vm._s(value)
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ]),
                              ]),
                              _c("br"),
                              _c("label", [_vm._v("Parámetros de ejecución")]),
                              _c("br"),
                              _c("span", [
                                _vm._v(
                                  "Valores del parámetro de canalización utilizados en esta ejecución"
                                ),
                              ]),
                              _vm._l(
                                _vm.detail_execution.tasks,
                                function (task) {
                                  return task.parent_task_id == 0
                                    ? _c(
                                        "table",
                                        [
                                          _c("tr", [
                                            _c("th", [_vm._v("Parámetro")]),
                                            _c("th", [_vm._v("Tipo")]),
                                            _c("th", [_vm._v("Valor")]),
                                          ]),
                                          _vm._l(
                                            task.execution.metadata_items,
                                            function (item) {
                                              return item.key.indexOf(
                                                "input"
                                              ) != -1
                                                ? _c("tr", [
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.key.replace(
                                                            "input:",
                                                            ""
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.value.split(
                                                            ":"
                                                          )[0]
                                                        )
                                                      ),
                                                    ]),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.value.split(
                                                            ":"
                                                          )[1]
                                                        )
                                                      ),
                                                    ]),
                                                  ])
                                                : _vm._e()
                                            }
                                          ),
                                        ],
                                        2
                                      )
                                    : _vm._e()
                                }
                              ),
                            ],
                            2
                          ),
                          _c(VTabItem, [
                            _c("br"),
                            !_vm.detail_node
                              ? _c("div", [
                                  _vm._v(
                                    " Selecciona un nodo para ver su información "
                                  ),
                                ])
                              : _vm._e(),
                            _vm.detail_node
                              ? _c(
                                  "div",
                                  [
                                    _c("label", [
                                      _vm._v("Información de ejecución "),
                                    ]),
                                    _c(
                                      VChip,
                                      {
                                        staticClass: "ml-1",
                                        attrs: {
                                          color:
                                            _vm.detail_node.state == 3
                                              ? "green"
                                              : _vm.detail_node.state == 7
                                              ? "red"
                                              : "grey",
                                          outlined: "",
                                          small: "",
                                          dense: "",
                                          variant: "flat",
                                        },
                                      },
                                      [
                                        _vm.detail_node.state == 3
                                          ? _c(
                                              VIcon,
                                              {
                                                attrs: { small: "", dense: "" },
                                              },
                                              [_vm._v("check")]
                                            )
                                          : _vm._e(),
                                        _vm.detail_node.state == 7
                                          ? _c(
                                              VIcon,
                                              {
                                                attrs: { small: "", dense: "" },
                                              },
                                              [_vm._v("warning")]
                                            )
                                          : _vm._e(),
                                        _vm.detail_node.state == 9
                                          ? _c(
                                              VIcon,
                                              {
                                                attrs: { small: "", dense: "" },
                                              },
                                              [_vm._v("cancel")]
                                            )
                                          : _vm._e(),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.detail_node.state_name) +
                                            " "
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("br"),
                                    _vm.detail_node && _vm.detail_node.log_file
                                      ? _c(
                                          VBtn,
                                          {
                                            staticClass: "ml-1",
                                            attrs: { small: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onDownloadLog(
                                                  _vm.detail_node,
                                                  _vm.detail_node.log_file
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("VER REGISTRO")]
                                        )
                                      : _vm._e(),
                                    _c("br"),
                                    _c("br"),
                                    _c("table", [
                                      _c("tr", [
                                        _c("th", [_vm._v("Nombre")]),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(_vm.detail_node.task_name)
                                          ),
                                        ]),
                                      ]),
                                      _c("tr", [
                                        _c("th", [_vm._v("Tipo")]),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.detail_node.execution
                                                .schema_title
                                            )
                                          ),
                                        ]),
                                      ]),
                                      _c("tr", [
                                        _c("th", [_vm._v("Duración")]),
                                        _c("td"),
                                      ]),
                                      _c("tr", [
                                        _c("th", [_vm._v("Iniciada")]),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.detail_node.start_time
                                                .substring(0, 19)
                                                .replace("T", " ")
                                            )
                                          ),
                                        ]),
                                      ]),
                                      _c("tr", [
                                        _c("th", [_vm._v("Finalizado")]),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.detail_node.end_time
                                                .substring(0, 19)
                                                .replace("T", " ")
                                            )
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                    _c("br"),
                                    _c("label", [
                                      _vm._v("Parámetros de entrada"),
                                    ]),
                                    _c("br"),
                                    _c(
                                      "table",
                                      [
                                        _c("tr", [
                                          _c("th", [_vm._v("Parámetro")]),
                                          _c("th", [_vm._v("Tipo")]),
                                          _c("th", [_vm._v("Valor")]),
                                        ]),
                                        _vm._l(
                                          _vm.detail_node.execution
                                            .metadata_items,
                                          function (item) {
                                            return item.key.indexOf("input") !=
                                              -1
                                              ? _c("tr", [
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.key.replace(
                                                          "input:",
                                                          ""
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.value.split(":")[0]
                                                      )
                                                    ),
                                                  ]),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.value.split(":")[1]
                                                      )
                                                    ),
                                                  ]),
                                                ])
                                              : _vm._e()
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                    _c("br"),
                                    _c("label", [
                                      _vm._v("Parámetros de salida"),
                                    ]),
                                    _c("br"),
                                    _c(
                                      "table",
                                      [
                                        _c("tr", [
                                          _c("th", [_vm._v("Parámetro")]),
                                          _c("th", [_vm._v("Tipo")]),
                                          _c("th", [_vm._v("Valor")]),
                                        ]),
                                        _vm._l(
                                          _vm.detail_node.execution
                                            .metadata_items,
                                          function (item) {
                                            return item.key.indexOf("output") !=
                                              -1
                                              ? _c("tr", [
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.key.replace(
                                                          "output:",
                                                          ""
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.value.split(":")[0]
                                                      )
                                                    ),
                                                  ]),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.value.split(":")[1]
                                                      )
                                                    ),
                                                  ]),
                                                ])
                                              : _vm._e()
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm.see_detail
                ? _c("div", { staticClass: "form-row" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c("label", [_vm._v("Registro de Eventos")]),
                      _c("br"),
                      _c(
                        "table",
                        { key: _vm.key_table_logs, staticClass: "table" },
                        [
                          _c("tr", [
                            _c("th", [_vm._v("Fecha y Hora")]),
                            _c("th", [_vm._v("Severidad")]),
                            _c("th", [_vm._v("Mensaje")]),
                          ]),
                          _vm.detail_node && _vm.detail_node.execution_logs
                            ? _c(
                                "tbody",
                                _vm._l(
                                  _vm.detail_node.execution_logs,
                                  function (item) {
                                    return _c("tr", [
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            item.timestamp
                                              .substring(0, 19)
                                              .replace("T", " ")
                                          )
                                        ),
                                      ]),
                                      _c("td", [_vm._v(_vm._s(item.severity))]),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            item.textPayload
                                              ? item.textPayload
                                              : item.jsonPayload
                                              ? item.jsonPayload.message
                                              : ""
                                          )
                                        ),
                                      ]),
                                    ])
                                  }
                                ),
                                0
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }